export let baseUrl = "https://admin.bcagency.vn/customer/tenant/api/v1";
export const API_URL = baseUrl;
export const API_CENTRAL_URL = "https://admin.amaiteam.com/customer/api/v1";
export let centralUrl = "https://admin.amaiteam.com/customer/api/v1";

export const GOOGLE_RECAPTCHA_KEY = '6Lf3pukaAAAAAKzLzKLy7JCZn9ZyoroQ36zpJ__q';
export const IS_MAINTAIN = false;
